export default __webpack_public_path__ + "assets/img/ic-avatar.06a29373dc59bcd7905d5d593ab11dd9.svg";